import { Channel } from 'lib-shared-types-channels';
import { useMemo } from 'react';

import {
  buildCopilotActions,
  type CopilotActionContext,
} from 'components/copilotActions';
import { CopilotAction } from 'components/copilotDropdown';

export interface ModalCopilotActions {
  editorCopilotActions: Record<string, CopilotAction>;
  internalNoteEditorCopilotActions: Record<string, CopilotAction>;
}

type UseGetComposeModalCopilotActionsArgs = {
  channel: Channel;
  /** Wording and action availability for the message editor. */
  context: CopilotActionContext;
  /** Same, for the internal note editor. */
  noteContext: CopilotActionContext;
};

/**
 * The copilot actions for a modal that composes a new message, which has both a
 * message and an internal note editor. Neither has a conversation yet, so no
 * `csid` is passed.
 */
export const useGetComposeModalCopilotActions = ({
  channel,
  context,
  noteContext,
}: UseGetComposeModalCopilotActionsArgs): ModalCopilotActions => {
  const params = useMemo(() => ({ channel }), [channel]);

  const editorCopilotActions = useMemo(
    () => buildCopilotActions(context, params),
    [context, params],
  );

  const internalNoteEditorCopilotActions = useMemo(
    () => buildCopilotActions(noteContext, params),
    [noteContext, params],
  );

  return { editorCopilotActions, internalNoteEditorCopilotActions };
};
